
export const GITHUB_CDN_URL = 'https://raw.githubusercontent.com/hptaikhoandev/oddsTableCdn/main'
export const BANKER = [
  {
    name: "Sbobet",
    value: "31",
  },
  {
    name: "M88",
    value: "17",
  },
  {
    name: "Macauslot",
    value: "1",
  },
  {
    name: "Crown",
    value: "3",
  },
  {
    name: "Ladbrokes",
    value: "4",
  },
  {
    name: "Bet365",
    value: "8",
  },
  {
    name: "Vcbet",
    value: "14",
  },
  {
    name: "10BET",
    value: "22",
  },
  {
    name: "188bet",
    value: "23",
  },
  {
    name: "18bet",
    value: "42",
  },
  {
    name: "Pinnacle",
    value: "47",
  },
];

export const LOCATION = [
  {
    name: "Châu Á",
    slug: "chau-a",
    bg: "bg-aqua-mint",
    bgCell: "bg-pale-aqua dark:bg-pale-dark-aqua",
  },
  {
    name: "Tài Xỉu",
    slug: "tai-xiu",
    bg: "bg-golden-sun",
    bgCell: "bg-yellow-pastel dark:bg-yellow-dark-pastel",
  },
  {
    name: "Châu Âu",
    slug: "chau-au",
    bg: "bg-blue-500 text-white",
    bgCell: "bg-cool-mist dark:bg-cool-dark-mist",
  },
];

export const CONTINENT = [
  {
    eng: 'World',
    vn: 'Thế giới',
    slug: 'the-gioi'
  },
  {
    eng: 'Europe',
    vn: 'Châu Âu',
    slug: 'chau-au'
  },
  {
    eng: 'Asia',
    vn: 'Châu Á',
    slug: 'chau-a'
  },
  {
    eng: 'South America',
    vn: 'Nam Mỹ',
    slug: 'nam-my'
  },
  {
    eng: 'Middle and North America',
    vn: 'Concacaf',
    slug: 'concacaf'
  },
  {
    eng: 'Africa',
    vn: 'Châu Phi',
    slug: 'chau-phi'
  },
  {
    eng: 'Oceania',
    vn: 'Châu Đại Dương',
    slug: 'chau-dai-duong'
  }
];

export const BANKER_EXTENDS = [
  {
    name: "TL HONGKONG",
    shortName: "HONGKONG",
    value: "hongkong",
  },
  {
    name: "TL DECIMAL",
    shortName: "DECIMAL",
    value: "decimal",
  },
  {
    name: "TL INDONESIA",
    shortName: "INDONESIA",
    value: "indo",
  },
  {
    name: "TL MALAYSIA",
    shortName: "MALAYSIA",
    value: "malay",
  }
];
export const LICH_THI_DAU_LIST = [
  {
    name: "Euro 2024",
    value: "euro2024",
  },
  {
    name: "Ngoại hạng Anh",
    value: "ngoaihanganh",
  },
  {
    name: "La Liga",
    value: "laliga",
  },
  {
    name: "Seri A",
    value: "seria",
  },
  {
    name: "Bundesliga",
    value: "bundesliga",
  },
  {
    name: "Ligue 1",
    value: "ligue1",
  },
  {
    name: "Cup C1 Châu Âu",
    value: "A",
  },
  {
    name: "VLeagu-e",
    value: "vleague",
  },
  {
    name: "Bóng đá nam Olympic Tokyo 2024",
    value: "bongdanamolympictokyo2024",
  },
  {
    name: "C2 Europa League",
    value: "c2europaleague",
  },
  {
    name: "C2 Europa League",
    value: "c2europaleague",
  },
  {
    name: "C2 Europa League",
    value: "c2europaleague",
  },
  {
    name: "C2 Europa League",
    value: "c2europaleague",
  },
  {
    name: "Cúp nhà vua TBN",
    value: "cupnhavuatbn",
  },
  {
    name: "Cúp Liên đoàn Anh",
    value: "cupliendoananh",
  },
  {
    name: "U19 Châu Á",
    value: "u19chaua",
  },
  {
    name: "A-league Úc",
    value: "aleagueuc",
  },
  {
    name: "Cúp C2 Châu Á-AFC Cúp",
    value: "cupc2chaua-afccup",
  },
];

export const SEARCH_TYPE = [
  {
    name: "Đội bóng",
    value: "doibong",
  },
  {
    name: "Giải đấu",
    value: "giaidau",
  },
  {
    name: "Khu vực",
    value: "khuvuc",
  },
];

export const FILTER_TYPE = [
  {
    name: "Giải đấu",
    value: "league",
  },
  {
    name: "Đội bóng",
    value: "team",
  },
];

export const FILTER_SORT = [
  {
    name: "A-Z",
    value: "az",
  },
  {
    name: "Z-A",
    value: "za",
  },
  {
    name: "Quốc gia",
    value: "country",
  },
];

export const LEAGUES_HOT = [
  {
      id: 1763,
      name: 'Euro 2024',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/UEFA-Champions-League.webp'
  },
  {
      id: 14228,
      name: 'Copa America',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/England-FA-Cup.webp'

  },
  {
      id: 1639,
      name: 'Ngoại hạng Anh',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Premier-League.webp'
  },
  {
      id: 1134,
      name: 'La Liga',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Italian-Serie-A.webp'
  },
  {
      id: 1437,
      name: 'Seri A',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Spanish-La-Liga.webp'
  },
  {
      id: 188,
      name: 'Bundesliga',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/German-Bundesliga.webp'
  },
  {
      id: 1112,
      name: 'Ligue 1',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/France-Ligue-1.webp'
  },
  {
      id: 13014,
      name: 'Cúp C1 Châu Âu',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 123612,
      name: 'Cúp Liên đoàn Anh',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 29931,
      name: 'U19 Châu Á',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 141511,
      name: 'A-league Úc',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 120428,
      name: 'AFC Cúp',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 13115,
      name: 'Cup C2 Châu Âu',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 178128,
      name: 'Cup C3 Châu Âu',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 16679,
      name: 'V-League',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 146819,
      name: 'UEFA Nations League',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 1527,
      name: 'VĐQG Nhật Bản',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 13722,
      name: 'VĐQG Australia',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 10077,
      name: 'VĐQG Thái Lan',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 12923,
      name: 'VĐQG Ả Rập Xê Út',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 1066,
      name: 'VĐQG Trung Quốc',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 120428,
      name: 'U20 Châu Á',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
  {
      id: 1347,
      name: 'Bóng đá nam Olympic Tokyo 2024',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp'
  },
];
export const LICHTHIDAU_LEAGUES = [
  {
      id: 0,
      name: 'Tất cả',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/UEFA-Champions-League.webp',
      type: 0,
  },
  // {
  //     id: 1763,
  //     name: 'Euro 2024',
  //     logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/UEFA-Champions-League.webp',
  //     type: 2,
  // },
  // {
  //     id: 14228,
  //     name: 'Copa America',
  //     logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/England-FA-Cup.webp',
  //     type: 2,

  // },
  {
      id: 1639,
      name: 'Ngoại hạng Anh',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Premier-League.webp',
      type: 1,
  },
  {
      id: 1134,
      name: 'La Liga',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Italian-Serie-A.webp',
      type: 1,
  },
  {
      id: 1437,
      name: 'Seri A',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Spanish-La-Liga.webp',
      type: 1,
  },
  {
      id: 1257,
      name: 'Bundesliga',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/German-Bundesliga.webp',
      type: 2,
  },
  {
      id: 1112,
      name: 'Ligue 1',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/France-Ligue-1.webp',
      type: 1,
  },
  {
      id: 13014,
      name: 'Cúp C1 Châu Âu',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
      type: 2,
  },
  {
      id: 123612,
      name: 'Cúp Liên đoàn Anh',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
      type: 2,
  },
  {
      id: 29931,
      name: 'U19 Châu Á',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
      type: 2,
  },
  {
      id: 141511,
      name: 'A-league Úc',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
      type: 1
  },
  {
      id: 120428,
      name: 'AFC Cúp',
      logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
      type: 2,
  },
];
export const LICHTHIDAU_RANGES_EVENT = [
  { vn_name: 'Vòng Bảng', en_name: 'Group' },
  { vn_name: 'Vòng Loại', en_name: 'Qual.' },
  { vn_name: 'Vòng 1/8', en_name: '1/8 Final' },
  { vn_name: 'Vòng Tứ Kết', en_name: 'Quarterfinals' },
  { vn_name: 'Vòng Bán Kết', en_name: 'Semifinals' },
  { vn_name: 'Chung Kết', en_name: 'Finals' },
  { vn_name: 'Chung Kết Knock-out', en_name: 'Playoff Final' },
  { vn_name: 'Vòng Knock-out', en_name: 'Playoffs' },
];
export const LICHTHIDAU_RANGES_CUP = [
  { vn_name: 'Vòng Sơ loại', en_name: 'Group' },
  { vn_name: 'Vòng 1', en_name: 'Round 1' },
  { vn_name: 'Vòng 2', en_name: 'Round 2' },
  { vn_name: 'Vòng 3', en_name: 'Round 3' },
  { vn_name: 'Vòng 4', en_name: 'Round 4' },
  { vn_name: 'Vòng 5', en_name: 'Round 5' },
  { vn_name: 'Vòng 6', en_name: 'Round 6' },
  { vn_name: 'Vòng 7', en_name: 'Round 7' },
  { vn_name: 'Vòng 8', en_name: 'Round 8' },
  { vn_name: 'Vòng 9', en_name: 'Round 9' },
  { vn_name: 'Vòng 10', en_name: 'Round 10' },
  { vn_name: 'Vòng Play-off', en_name: 'Playoffs' },
  { vn_name: 'Vòng Bảng', en_name: 'League Round' },
  { vn_name: 'Vòng 1/8 đội', en_name: '1/8 Final' },
  { vn_name: 'Vòng Tứ Kết', en_name: 'Quarterfinals' },
  { vn_name: 'Vòng Bán Kết', en_name: 'Semifinals' },
  { vn_name: 'Vòng Chung Kết', en_name: 'Finals' },

];
export const LICHTHIDAU_RANGES_LEAGUE = [
  { vn_name: 'Vòng 1', en_name: '1' },
  { vn_name: 'Vòng 2', en_name: '2' },
  { vn_name: 'Vòng 3', en_name: '3' },
  { vn_name: 'Vòng 4', en_name: '4' },
  { vn_name: 'Vòng 5', en_name: '5' },
  { vn_name: 'Vòng 6', en_name: '6' },
  { vn_name: 'Vòng 7', en_name: '7' },
  { vn_name: 'Vòng 8', en_name: '8' },
  { vn_name: 'Vòng 9', en_name: '9' },
  { vn_name: 'Vòng 10', en_name: '10' },
  { vn_name: 'Vòng 11', en_name: '11' },
  { vn_name: 'Vòng 12', en_name: '12' },
  { vn_name: 'Vòng 13', en_name: '13' },
  { vn_name: 'Vòng 14', en_name: '14' },
  { vn_name: 'Vòng 15', en_name: '15' },
  { vn_name: 'Vòng 16', en_name: '16' },
  { vn_name: 'Vòng 17', en_name: '17' },
  { vn_name: 'Vòng 18', en_name: '18' },
  { vn_name: 'Vòng 19', en_name: '19' },
  { vn_name: 'Vòng 20', en_name: '20' },
  { vn_name: 'Vòng 21', en_name: '21' },
  { vn_name: 'Vòng 22', en_name: '22' },
  { vn_name: 'Vòng 23', en_name: '23' },
  { vn_name: 'Vòng 24', en_name: '24' },
  { vn_name: 'Vòng 25', en_name: '25' },
  { vn_name: 'Vòng 26', en_name: '26' },
  { vn_name: 'Vòng 27', en_name: '27' },
  { vn_name: 'Vòng 28', en_name: '28' },
  { vn_name: 'Vòng 29', en_name: '29' },
  { vn_name: 'Vòng 30', en_name: '30' },
  { vn_name: 'Vòng 31', en_name: '31' },
  { vn_name: 'Vòng 32', en_name: '32' },
  { vn_name: 'Vòng 33', en_name: '33' },
  { vn_name: 'Vòng 34', en_name: '34' },
  { vn_name: 'Vòng 35', en_name: '35' },
  { vn_name: 'Vòng 36', en_name: '36' },
  { vn_name: 'Vòng 37', en_name: '37' },
  { vn_name: 'Vòng 38', en_name: '38' },
  { vn_name: 'Vòng 39', en_name: '39' },
  { vn_name: 'Vòng 40', en_name: '40' },
];

export const ALL = "tatca";
export const LIVE = "keotructuyen";
export const RESULT = "ketqua";
export const FAVORITE = "yeuthich";
export const VIEW_ALL = "xemtatca";
export const FAVORITE_PROCESSING = "yeuthich-dangdienra";
export const FAVORITE_NOTSTARTED = "yeuthich-chuadienra";
export const FAVORITE_FINISHED = "yeuthich-ketthuc";
export const SEARCH_TYPE_LEAGUE = "giaidau";
export const SEARCH_TYPE_LEAGUES = "giaidaus";
export const SEARCH_TYPE_TEAM = "doibong";
export const SEARCH_TYPE_TEAMS = "doibongs";
export const SEARCH_TYPE_COUNTRY = "khuvuc";
export const SEARCH_HOT_LEAGUE_DEFAULT = "Giải Bóng HOT";

export const LEAGUES_ALL = [
  "1437", "1639", "1099", "133", "144", "155", "188", "1011", "1112", "1516",
  "1325", "1527", "1628", "1134", "1066", "1987", "13014", "13115", "19111", "19212",
  "12316", "14127", "10325", "13621", "12923", "11034", "13036", "18132", "12237", "15230",
  "15645", "16646", "14150", "184013", "16679", "176317", "182022", "178128", "1011", "1527",
  "2521", "2232", "1822", "1845", "1848", "1849", "1850", "1851", "1852", "1853",
  "1854", "1855", "1856", "1857", "1858", "1860", "1861", "1862", "1863", "1864",
  "1865", "1866", "1867", "1868", "1869", "1870", "1871", "1872", "1873", "1874",
  "1875", "1876", "1877", "1878", "1879", "1880", "1881", "1882", "1883", "1884",
  "1885", "1886", "1887", "1888", "1889", "1890", "1891", "1892", "1893", "1894",
  "1895", "1896", "1897", "1898", "1899", "1900", "1763", "177419", "155123", "153525",
  "16343", "165315", "134524", "135222", "166316", "161423", "133411", "166316", "165326", "134524"
];

export const TABLE_CUP = [
  {
      "table": "A",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "B",
      "class": "bg-green-500 text-white"
  },
  {
      "table": "C",
      "class": "bg-yellow-500 text-black"
  },
  {
      "table": "D",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "E",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "F",
      "class": "bg-yellow-500 text-white"
  },
  {
      "table": "G",
      "class": "bg-red-500 text-black"
  },
  {
      "table": "H",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "I",
      "class": "bg-yellow-500 text-black"
  },
  {
      "table": "J",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "K",
      "class": "bg-dark-charcoal text-white"
  },
  {
      "table": "L",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "M",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "N",
      "class": "bg-dark-charcoal text-white"
  },
  {
      "table": "O",
      "class": "bg-dark-charcoal text-white"
  },
  {
      "table": "P",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "Q",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "R",
      "class": "bg-dark-charcoal text-white"
  },
  {
      "table": "S",
      "class": "bg-red-500 text-black"
  },
  {
      "table": "T",
      "class": "bg-red-500 text-black"
  },
  {
      "table": "U",
      "class": "bg-yellow-500 text-white"
  },
  {
      "table": "V",
      "class": "bg-yellow-500 text-white"
  },
  {
      "table": "W",
      "class": "bg-red-500 text-white"
  },
  {
      "table": "X",
      "class": "bg-red-500 text-black"
  },
  {
      "table": "Y",
      "class": "bg-yellow-500 text-white"
  },
  {
      "table": "Z",
      "class": "bg-red-500 text-white"
  }
];

export const LEAGUES_CUP = [
  14228, 
  1763
]
export const AMOUNT_VIEW_MORE = 100;

export const EVENT_MAPPING = {
  1: {
      name: "Bàn thắng",
      // iconImgLink: 'http://bongdaso66.net/img/ball.gif'
      iconImgLink: `${GITHUB_CDN_URL}/images/goal.svg`
  },
  2: {
      name: "Thẻ đỏ",
      iconImgLink: `${GITHUB_CDN_URL}/images/red_card.png`
  },
  3: {
      name: "Thẻ vàng",
      iconImgLink: `${GITHUB_CDN_URL}/images/yellow_new_card.png`
  },
  7: {
      name: "Penalty",
      iconImgLink: `${GITHUB_CDN_URL}/images/penalty.svg`
  },
  8: {
      name: "Phản lưới nhà",
      iconImgLink: `${GITHUB_CDN_URL}/images/phan_luoi.png`
  },
  9: {
      name: "Thẻ vàng thứ 2",
      iconImgLink: `${GITHUB_CDN_URL}/images/the_vang_thu_2.png`
  },
  11: {
      name: "Thay người",
      iconImgLink: `${GITHUB_CDN_URL}/images/thay_nguoi.svg`
  },
  13: {
      name: "Bỏ lỡ penalty",
      iconImgLink: `${GITHUB_CDN_URL}/images/miss_pen.png`
  },
  14: {
      name: "VAR (VDO hỗ trợ trọng tài)",
      iconImgLink: `${GITHUB_CDN_URL}/images/var.png`
  }
};


export const LEAGUES = [
  {
    "id": 1639,
    "name": "Ngoại hạng Anh",
    "type": 1
  },
  {
    "id": 1763,
    "name": "Euro",
    "type": 2
  },
{
  "id": 13014,
  "name": "C1",
  "type": 2
},
{
  "id": 13115,
  "name": "C2",
  "type": 2
},

  {
    "id": 1134,
    "name": "La Liga",
    "type": 1
  },
  {
    "id": 188,
    "name": "Bundesliga",
    "type": 1
},

{
  "id": 1112,
  "name": "Ligue 1",
  "type": 1
},
{
  "id": 1437,
  "name": "Serie A",
  "type": 1
},
{
  "id": 16679,
  "name": "V.League 1",
  "type": 1
},
  {
      "id": 133,
      "name": "Austrian Bundesliga",
      "type": 1
  },
  {
      "id": 144,
      "name": "Brazil Serie A",
      "type": 1
  },
  {
      "id": 155,
      "name": "Belgian Pro League",
      "type": 1
  },

  {
      "id": 1011,
      "name": "Russia Premier League",
      "type": 1
  },
  {
      "id": 1066,
      "name": "Chinese Super League",
      "type": 1
  },
  {
      "id": 1325,
      "name": "Liga Portugal 1",
      "type": 1
  },

  {
      "id": 1516,
      "name": "K League 1",
      "type": 1
  },
  {
      "id": 1527,
      "name": "J1 League",
      "type": 1
  },
  {
      "id": 1628,
      "name": "Swedish Allsvenskan",
      "type": 1
  },

  {
      "id": 1853,
      "name": "Johan Cruijff Schaal",
      "type": 2
  },
  {
      "id": 1875,
      "name": "Scotland FA Cup",
      "type": 2
  },
  {
      "id": 1886,
      "name": "FIFA Confederations Cup",
      "type": 2
  },
  {
      "id": 1987,
      "name": "Copa Libertadores",
      "type": 2
  },
  {
      "id": 10325,
      "name": "Belarusian Premier League",
      "type": 1
  },
  {
      "id": 11034,
      "name": "UAE Pro-League",
      "type": 1
  },
  {
      "id": 12237,
      "name": "Kuwaiti Premier League",
      "type": 1
  },
  {
      "id": 12316,
      "name": "Slovak Super Liga",
      "type": 1
  },
  {
      "id": 12923,
      "name": "Saudi Professional League",
      "type": 1
  },
  {
      "id": 13014,
      "name": "UEFA Champions League",
      "type": 2
  },
  {
      "id": 13036,
      "name": "Egyptian Premier League",
      "type": 1
  },

  {
      "id": 13621,
      "name": "Copa Sudamericana",
      "type": 2
  },
  {
      "id": 14127,
      "name": "Latvian Higher League",
      "type": 1
  },
  {
      "id": 14150,
      "name": "Luxembourg National Division",
      "type": 1
  },
  {
      "id": 15230,
      "name": "Lebanese Premier League",
      "type": 1
  },
  {
      "id": 15645,
      "name": "Yemeni League",
      "type": 1
  },
  {
      "id": 16343,
      "name": "VIC Premier League",
      "type": 1
  },
  {
      "id": 16646,
      "name": "Kazakhstan Premier League",
      "type": 1
  },

  {
      "id": 18132,
      "name": "Bahraini Premier League",
      "type": 1
  },
  {
      "id": 19111,
      "name": "Ukrainian Premier League",
      "type": 1
  },
  {
      "id": 19212,
      "name": "Serbian Superliga",
      "type": 1
  },
  {
      "id": 133411,
      "name": "Russia Division 2",
      "type": 1
  },
  {
      "id": 134524,
      "name": "Nigeria National League",
      "type": 1
  },
  {
      "id": 135222,
      "name": "NSW Premier W-League",
      "type": 1
  },
  {
      "id": 153525,
      "name": "Australia NPL Victoria U23",
      "type": 1
  },
  {
      "id": 155123,
      "name": "USA Independent League",
      "type": 1
  },
  {
      "id": 161423,
      "name": "Myanmar League Women",
      "type": 1
  },
  {
      "id": 165315,
      "name": "Australia FFA Cup",
      "type": 2
  },
  {
      "id": 165326,
      "name": "Uzbekistan Pro League",
      "type": 1
  },
  {
      "id": 166316,
      "name": "International Friendly",
      "type": 2
  },
  {
      "id": 176317,
      "name": "Indian Super League",
      "type": 1
  },
  {
      "id": 177419,
      "name": "USA Women Premier League",
      "type": 1
  },
  {
      "id": 178128,
      "name": "UEFA Conference League",
      "type": 2
  },
  {
      "id": 182022,
      "name": "Canadian Premier League",
      "type": 1
  },
  {
      "id": 184013,
      "name": "Thai League 2",
      "type": 1
  }
]

export const BXH_LEAGUES = [

  {
    "id": 1639,
    "name": "Ngoại hạng Anh",
    "slug": "ngoai-hang-anh",
    "type": 1
  },

  {
    "id": 1134,
    "name": "La Liga",
    "slug": "la-liga",
    "type": 1
  },
  {
    "id": 1437,
    "name": "Serie A",
    "slug": "serie-a",
    "type": 1
  },
  {
    "id": 188,
    "name": "Bundesliga",
    "slug": "bundesliga",
    "type": 1
  },
  {
    "id": 1112,
    "name": "Ligue 1",
    "slug": "ligue-1",
    "type": 1
  },
  {
    "id": 13014,
    "name": "Cup C1 Châu Âu",
    "slug": "cup-c1-chau-au",
    "type": 2
  },
  {
    "id": 13115,
    "name": "C2 Europa League",
    "slug": "c2-europa-league",
    "type": 2
  },
  {
    "id": 16679,
    "name": "V.League 1",
    "slug": "v-league-1",
    "type": 1
  },
  {
    'id': 1347,
    'name': 'Bóng đá nam Olympic Tokyo 2024',
    'slug': 'bong-da-nam-olympic-tokyo-2024',
    "type": 2
  },
  // {
  //   "id": 1763,
  //   "name": "Euro 2024",
  //   "slug": "euro-2024",
  //   "type": 2
  // },
];


export const BREADCRUMB = [
  { "name": "Ngoại hạng Anh", "slug": "ngoai-hang-anh" },
  { "name": "La Liga", "slug": "la-liga" },
  { "name": "Serie A", "slug": "serie-a" },
  { "name": "Bundesliga", "slug": "bundesliga" },
  { "name": "Ligue 1", "slug": "ligue-1" },
  { "name": "Cup C1 Châu Âu", "slug": "cup-c1-chau-au" },
  { "name": "C2 Europa League", "slug": "c2-europa-league" },
  { "name": "V.League 1", "slug": "v-league-1" },
  { "name": "Bóng đá nam Olympic Tokyo 2024", "slug": "bong-da-nam-olympic-tokyo-2024" },
  { "name": "Euro 2024", "slug": "euro-2024" },
  { "name": "Bảng Xếp Hạng", "slug": "bang-xep-hang" },
  { "name": "Top Ghi Bàn", "slug": "top-ghi-ban" },
  { "name": "BXH Fifa Nam", "slug": "bxh-fifa-nam" },
  { "name": "BXH Fifa Nữ", "slug": "bxh-fifa-nu" },
  { "name": "Nam", "slug": "nam" },
  { "name": "Nữ", "slug": "nu" },
  { "name": "Thế giới", "slug": "the-gioi" },
  { "name": "Châu Âu", "slug": "chau-au" },
  { "name": "Châu Á", "slug": "chau-a" },
  { "name": "Nam Mỹ", "slug": "nam-my" },
  { "name": "Concacaf", "slug": "concacaf" },
  { "name": "Châu Phi", "slug": "chau-phi" },
  { "name": "Châu Đại Dương", "slug": "chau-dai-duong" }
];

export const ALPHABET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const SOC88URL = "https://soc88.com/";

export const LEAGUES_PLUGINS = [
    { id: 1639, name: "Ngoại hạng Anh", type: 1 },         
    { id: 1134, name: "La Liga", type: 1 },              
    { id: 13014, name: "Cup C1 Châu Âu", type: 2 },      
    { id: 146819, name: "UEFA Nations League", type: 2 },
    { id: 1437, name: "Serie A", type: 1 },
    { id: 188, name: "Bundesliga", type: 1 },
    { id: 1112, name: "Ligue 1", type: 1 },
    { id: 16679, name: "V-League", type: 1 },
    { id: 13115, name: "Cup C2 Châu Âu", type: 2 },
    { id: 178128, name: "C3 Châu Âu", type: 2 },
    { id: 1527, name: "VĐQG Nhật Bản", type: 1 },
    { id: 13722, name: "VĐQG Australia", type: 1 },
    { id: 1123, name: "VĐQG Mỹ", type: 1 },
    { id: 10077, name: "VĐQG Thái Lan", type: 1 },
    { id: 12923, name: "VĐQG Ả Rập Xê Út", type: 1 },
    { id: 1066, name: "VĐQG Trung Quốc", type: 1 },
    { id: 120428, name: "U20 Châu Á", type: 2 }
  ];

  export const MATCH_STATUS = {
    NOT_STARTED: 0,
    FIRST_HALF: 1,
    HALF_TIME_BREAK: 2,
    SECOND_HALF: 3,
    EXTRA_TIME: 4,
    PENALTY: 5,
    FINISHED: -1,
    CANCELLED: 7,
    TBD: 8,
    TERMINATED: 9,
    INTERRUPTED: 10,
    POSTPONED: 11,
  };
  
  export const STATUS = MATCH_STATUS;
  
  export const LIVE_STATUSES = [1, 2, 3, 4, 5];
  export const FINISHED_STATUSES = [-1, -14, -10, -11, -12, -13];
  export const NOT_STARTED_STATUS = [0];
  export const CANCEL_STATUS = [-14, -10, -11, -12, -13];
  export const BANG_KEO_PAGE_LIMIT = 10;
  export const BANG_KEO_PAGE_PLUGIN_V1_LIMIT = 3;
